import { render, staticRenderFns } from "./robotView2.vue?vue&type=template&id=694e4780&scoped=true"
import script from "./robotView2.vue?vue&type=script&lang=js"
export * from "./robotView2.vue?vue&type=script&lang=js"
import style0 from "./robotView2.vue?vue&type=style&index=0&id=694e4780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e4780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694e4780')) {
      api.createRecord('694e4780', component.options)
    } else {
      api.reload('694e4780', component.options)
    }
    module.hot.accept("./robotView2.vue?vue&type=template&id=694e4780&scoped=true", function () {
      api.rerender('694e4780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/robotView2.vue"
export default component.exports